import { removeInvalidItems } from '@/services/adapters/transformations/removeInvalidItems'
import { transformSanityResources } from '@/services/adapters/transformations/transformSanityResources'
import { transformSanityTips } from '@/services/adapters/transformations/transformSanityTips'
import {
  IRemedyPair,
  RemedyCostReferenceSchema,
  RemedyEffectReferenceSchema,
  RemedyPairSchema
} from '@lifk/types'
import { z } from 'zod'

const sanitizeLevel = (level: string) => level.replace(/[+]/, '')

export const transformSanityRemedy = (
  rawRemedy: any,
  disableValidations: boolean
) => {
  // Effects
  const effectReferences = (rawRemedy.effects ?? []).map((effect: any) => {
    effect.level = sanitizeLevel(effect.level)
    return effect
  })
  const effectValidation = z
    .array(RemedyEffectReferenceSchema)
    .safeParse(effectReferences)
  let effects = effectValidation.data ?? []
  if (!effectValidation.success) {
    effects = removeInvalidItems(
      effectReferences,
      effectValidation.error,
      disableValidations
    )
  }
  rawRemedy.effects = effects

  // Costs
  const costValidation = z
    .array(RemedyCostReferenceSchema)
    .safeParse(rawRemedy.budgets)
  let costs = costValidation.data ?? []
  if (!costValidation.success) {
    costs = removeInvalidItems(
      rawRemedy.budgets,
      costValidation.error,
      disableValidations
    )
  }
  rawRemedy.budgets = costs

  // Tips
  rawRemedy.tips = rawRemedy.tips
    ? transformSanityTips(rawRemedy.tips, disableValidations)
    : []

  // Resources
  rawRemedy.resources = rawRemedy.resources
    ? transformSanityResources(rawRemedy.resources, disableValidations)
    : []

  // Pairings
  if (rawRemedy.pairings) {
    const validation = z.array(RemedyPairSchema).safeParse(rawRemedy.pairings)
    let pairings: IRemedyPair[] = validation.data ?? []
    if (!validation.success) {
      pairings = removeInvalidItems(
        rawRemedy.pairings,
        validation.error,
        disableValidations
      )
    }
    rawRemedy.pairings = pairings
  }
  if (!rawRemedy.pairings) {
    rawRemedy.pairings = []
  }

  return rawRemedy
}
